export default __webpack_public_path__ + "static/media/imd-partnership-logo.fb37e6b5.svg";